define.alias("ember-math-helpers/helpers/atan", "settings/helpers/atan");